<!-- ============================================================== -->
<!-- toggle and nav items -->
<!-- ============================================================== -->
<ul class="navbar-nav float-left mr-auto">
	<li class="nav-item d-none d-lg-block">
		<a (click)="toggleSidebar.emit()" class="nav-link sidebartoggler waves-effect waves-light"
			 href="javascript:void(0)">
			<i class="ti-menu"></i>
		</a>
	</li>
</ul>
<!-- ============================================================== -->
<!-- Right side toggle and nav items -->
<!-- ============================================================== -->
<ul class="navbar-nav float-right">

	<li *ngIf="banner" class="d-flex align-items-center gap-2">
		<a [routerLink]="banner.link"
			 class="d-inline-flex px-2 py-1 fw-semibold text-danger bg-warning bg-opacity-10 border border-opacity-10 rounded-2 gap-2"
			 href="javascript:void(0)" ngbTooltip="{{ banner.hint }}"
			 placement="bottom">
			 <span class="d-block d-md-none text-nowrap overflow-auto" style="max-width: 175px;">{{ banner.message }}</span>
			 <span class="d-none d-md-block">{{ banner.message }}</span>
			
			<span class="mdi mdi-chevron-right"></span>
		</a>
	</li>

	<!-- ============================================================== -->
	<!-- Notification -->
	<!-- ============================================================== -->
	<li class="nav-item dropdown" ngbDropdown placement="bottom-right">
		<a aria-expanded="false" aria-haspopup="true" class="nav-link dropdown-toggle waves-effect waves-dark"
			 data-toggle="dropdown" href="javascript:void(0)" ngbDropdownToggle>
      <span *ngIf="getUnreadNotifications().length > 0"
						class="badge bg-primary">{{ getUnreadNotifications().length }}</span>
			<i class="mdi mdi-bell font-24"></i>
			<div *ngIf="false" class="notify"><span class="heartbit"></span> <span class="point"></span></div>
		</a>
		<div class="dropdown-menu dropdown-menu-right mailbox at-mailbox-modern rounded-3 shadow py-0" ngbDropdownMenu>
			<ul class="list-style-none mb-0 ps-0">
				<li class="border-bottom">
					<div class="drop-title at-mailbox-header text-dark fw-semibold">Notifications</div>
				</li>
				<li class="position-relative">
					<ng-scrollbar *ngIf="notifications.length" [sensorDebounce]="1" autoHeightDisabled="false" class="message-center notifications">
						<a *ngFor="let notification of notifications"
						   class="message-item at-notification-item d-flex gap-3 text-start text-decoration-none"
						   [class.at-notification-unread]="!notification.is_read"
						   href="javascript:void(0)"
						   (click)="onNotificationClick(notification)">
							<span class="at-notification-icon flex-shrink-0 d-inline-flex align-items-center justify-content-center rounded-2" [ngClass]="merchantNotifications.mdiIcon(notification)" aria-hidden="true"></span>
							<span class="at-notification-text flex-grow-1 min-width-0">
								@if (notification.title) {
								<span class="at-notification-title d-block">{{ notification.title }}</span>
								}
								@if (notification.message) {
								<span class="at-notification-desc d-block">{{ notification.message }}</span>
								}
								@if (notification.displayTime) {
								<span class="at-notification-time d-block">{{ notification.displayTime }}</span>
								}
							</span>
						</a>
					</ng-scrollbar>
					@if (!notifications.length) {
					<p class="at-notification-empty mb-0 text-muted small px-4 py-4">You're all caught up.</p>
					}
				</li>
				<li class="border-top bg-light rounded-bottom">
					<a class="dropdown-item text-center fw-medium py-3 at-mailbox-footer-link"
					   routerLink="/dashboard"
					   fragment="merchant-setup-notifications"
					   (click)="navBarToggle.emit()">
						Jump to Notifications
						<i aria-hidden="true" class="mdi mdi-chevron-double-down ms-1"></i>
					</a>
				</li>
			</ul>
		</div>
	</li>
	<!-- ============================================================== -->
	<!-- End Notification -->
	<!-- ============================================================== -->


	<!-- ============================================================== -->
	<!-- User profile and search -->
	<!-- ============================================================== -->
	<li>
		<div class="h-100 nav-divider"></div>
	</li>
	<li class="nav-item" ngbDropdown placement="bottom-right">
		<a aria-expanded="false" aria-haspopup="true"
			 class="nav-link text-light fw-semibold-2 waves-effect waves-dark pro-pic" data-toggle="dropdown" href="javascript:void(0)"
			 ngbDropdownToggle>
			{{ user?.businessName }}
			<i aria-hidden="true" class="mdi mdi-chevron-down m-r-5 m-l-5"></i>
		</a>
		<div class="dropdown-menu-right user-dd py-2" ngbDropdownMenu>

			<ng-container *ngIf="FEATURE_FLAG.multi_account_switch && user.hasMultipleBusinesses">
				<a (click)="navBarToggle.emit()" [routerLink]="['/switch']" class="dropdown-item">
					<i aria-hidden="true" class="ti-layers m-r-5 m-l-5"></i> Switch Companies
				</a>

				<div class="dropdown-divider border-2 border-secondary-subtle"></div>
			</ng-container>

			<ng-container *ngIf="isCognitoAdmin || showAutofilerConsole">
				<a *ngIf="isCognitoAdmin" (click)="openAdminConsole(); navBarToggle.emit()" class="dropdown-item" href="javascript:void(0)">
					<i aria-hidden="true" class="mdi mdi-shield-account-outline m-r-5 m-l-5"></i> Admin console
				</a>

				<a *ngIf="showAutofilerConsole" (click)="openAutofilerConsole(); navBarToggle.emit()" class="dropdown-item" href="javascript:void(0)">
					<i aria-hidden="true" class="mdi mdi-file-document-edit-outline m-r-5 m-l-5"></i> AutoFiler
				</a>

				<div class="dropdown-divider border-2 border-secondary-subtle"></div>
			</ng-container>

			<div class="px-3 py-2">
				<div class="m-l-10">
					<h5 class="mb-0 font-16 fw-bold">
						{{ user?.firstName | titlecase }} {{ user?.lastName }}
					</h5>
					<p class="text-black-50 m-b-0 font-14">{{ user?.email }}</p>
				</div>
			</div>

			<a (click)="navBarToggle.emit()" [routerLink]="['/account-settings']" class="dropdown-item">
				<i aria-hidden="true" class="ti-settings m-r-5 m-l-5"></i> Account Settings
			</a>

			<a (click)="navBarToggle.emit()" class="dropdown-item" href="https://help.atomictax.com/" target="_blank">
				<i aria-hidden="true" class="mdi mdi-help-circle-outline m-r-5 m-l-5"></i> Support
			</a>

			<a (click)="logOut.emit()" class="dropdown-item" href="javascript:void(0)">
				<i aria-hidden="true" class="mdi mdi-logout m-r-5 m-l-5"></i> Logout
			</a>
		</div>
	</li>
	<!-- ============================================================== -->
	<!-- User profile and search -->
	<!-- ============================================================== -->
</ul>
